"use client";

import { createContext, useContext } from "react";

const NotificationPanelLockContext = createContext<(locked: boolean) => void>(
  () => {},
);

export const NotificationPanelLockProvider =
  NotificationPanelLockContext.Provider;

export function useNotificationPanelLock() {
  return useContext(NotificationPanelLockContext);
}
